import { useEffect, useState } from 'react';
import HomeScreen from './components/HomeScreen.jsx';
import QuizScreen from './components/QuizScreen.jsx';
import ResultsScreen from './components/ResultsScreen.jsx';
import { captureIncomingReferral, track } from './utils/tracking.js';

export default function App() {
  const [screen, setScreen] = useState('home'); // 'home' | 'quiz' | 'results'
  const [config, setConfig] = useState(null);   // { mode, scope }
  const [result, setResult] = useState(null);   // { score, total, answers, mode, scope }

  useEffect(() => {
    // Dev convenience: ?reset=email clears the email-submitted flag so the form
    // re-appears; ?reset=all clears all quiz localStorage keys.
    try {
      const params = new URLSearchParams(window.location.search);
      const resetMode = params.get('reset');
      if (resetMode === 'all') {
        ['quiz_email_submitted_v1', 'quiz_scores_v1', 'quiz_played_v1', 'quiz_referral_id_v1', 'quiz_referrer_id_v1']
          .forEach(k => localStorage.removeItem(k));
      } else if (resetMode === 'email') {
        localStorage.removeItem('quiz_email_submitted_v1');
      }
    } catch {}
    captureIncomingReferral();
    track('session_start');
  }, []);

  function startQuiz(mode, scope) {
    setConfig({ mode, scope });
    setScreen('quiz');
  }

  function finishQuiz(payload) {
    setResult({ ...payload, mode: config.mode, scope: config.scope });
    setScreen('results');
  }

  function playAgain() {
    setResult(null);
    setScreen('quiz');
  }

  function returnHome() {
    setResult(null);
    setConfig(null);
    setScreen('home');
  }

  return (
    <div className="app">
      <div className="shell">
        <header className="topbar">
          <a
            className="brand-logo"
            href="https://opened.co"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="OpenEd"
          >
            <img src="/opened-logo.png" alt="OpenEd" />
          </a>
          <div className="brand">
            The <em>OpenEd</em><span className="brand-sep">·</span>State Capital Quiz
          </div>
        </header>

        {screen === 'home' && <HomeScreen onStart={startQuiz} />}

        {screen === 'quiz' && (
          <QuizScreen
            mode={config.mode}
            scope={config.scope}
            onFinish={finishQuiz}
            onQuit={returnHome}
          />
        )}

        {screen === 'results' && (
          <ResultsScreen
            result={result}
            onPlayAgain={playAgain}
            onHome={returnHome}
          />
        )}

        <footer className="footer">
          <span className="footer-tag">
            Resources and support for homeschool families, in 15 states and growing.
          </span>
          <a href="https://opened.co" target="_blank" rel="noopener noreferrer">
            Learn more about OpenEd →
          </a>
        </footer>
      </div>
    </div>
  );
}
